module.exports = __webpack_public_path__ + "static/media/farmx-logo-square-white.31cb297a.png";